import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AmplifyModelService } from '../services/amplify-model-service.service';

@Injectable({
  providedIn: 'root'
})
export class SalesGuard implements CanActivate {
  private authService = inject(AmplifyModelService);
  private router = inject(Router);

  async canActivate(): Promise<boolean> {
    try {
      console.log('🛡️ SalesGuard - Checking sales access...');
      const groups = await this.authService.getUserGroups();
      console.log('👥 SalesGuard - User groups:', groups);
      
      if (groups.includes('SALES_REPS') || groups.includes('ADMINS')) {
        console.log('✅ SalesGuard - Access granted (user is sales rep or admin)');
        return true;
      }
      
      console.log('❌ SalesGuard - Access denied (user is not sales rep or admin)');
      // Redirect to appropriate portal based on their actual groups
      const defaultRoute = this.getDefaultRouteForGroups(groups);
      console.log('🔄 SalesGuard - Redirecting to:', defaultRoute);
      this.router.navigate([defaultRoute]);
      return false;
    } catch (error) {
      console.log('🚫 SalesGuard - Authentication error, redirecting to login');
      console.error('SalesGuard error:', error);
      this.router.navigate(['/login']);
      return false;
    }
  }

  private getDefaultRouteForGroups(groups: string[]): string {
    if (groups.includes('Technicians')) return '/dashboard';
    return '/dashboard';
  }
}